import { useState, useEffect } from "react";
import {
  selectCollections,
  selectUser,
  setEditingCollection,
  setSelectedSubMenu,
} from "../../redux/features/appData";
import { useSelector } from "react-redux";
import "./CollectionCardTable.css";
import { formatDate } from "winslow-core";
import { prettyCollectionAccessType } from "./collectionHelpers";
import { apiResyncCollection } from "../../services/CollectionService";
import toast from "react-hot-toast";
import { toastFail } from "../../config";
import { apiGetCollectionQuestionCountForUserInWorkspace } from "../../services/CollectionService";
import { CollectionQuestionCount } from "../../services/CollectionService.types";
import { useNavigate } from "react-router-dom";
import { iconPath } from "winslow-core";
import ModalCollectionDelete from "./ModalCollectionDelete";
import { useDispatch } from "react-redux";
import { MENUS } from "../config/menus";
import { Collection, EmbedCollectionResult } from "winslow-core";

export const CollectionCardTable = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const storeUser = useSelector(selectUser);
  const collections = useSelector(selectCollections);

  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [deleteCollectionId, setDeleteCollectionId] = useState<string>("");

  const [collectionQuestionCount, setCollectionQuestionCount] = useState<
    CollectionQuestionCount[] | null
  >(null);

  useEffect(() => {
    if (storeUser && collections && !collectionQuestionCount) {
      (async () => {
        if (storeUser.currentWorkspaceId) {
          const cqCount = await apiGetCollectionQuestionCountForUserInWorkspace(
            storeUser.currentWorkspaceId,
            storeUser.id
          );

          setCollectionQuestionCount(cqCount);
        }
      })();
    }
  }, []);

  const handleEditCollection = (collectionId: string) => {
    if (!collections) {
      return;
    }

    const index = collections.findIndex((collection: Collection) => {
      return collection.id === collectionId;
    });

    if (index === -1) {
      return;
    }

    dispatch(setEditingCollection(collections[index]));
    navigate("/create");
  };

  const getCollectionQuestionCount = (collectionId: string) => {
    if (!collectionQuestionCount) {
      return 0;
    }

    const index = collectionQuestionCount.findIndex(
      (cqc: CollectionQuestionCount) => {
        return cqc.collectionId === collectionId;
      }
    );

    if (index === -1) {
      return 0;
    }

    return collectionQuestionCount[index].count;
  };

  let myCollections: Collection[] = collections
    ? collections?.filter((collection: Collection) => {
        return collection.userId === storeUser?.id;
      })
    : [];

  myCollections.sort((a: Collection, b: Collection) => {
    return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
  });

  return (
    <>
      <table id="collection-card-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Date Created</th>
            <th>Questions Asked</th>
            <th>Last Synced</th>
            <th>Sharing</th>
            <th>&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          {myCollections &&
            myCollections.length > 0 &&
            myCollections.map((collection: Collection) => {
              return (
                <tr
                  key={"collection-card-table-row=" + collection.id}
                  id="collection-card-table-tr">
                  <td
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      dispatch(setSelectedSubMenu(MENUS.COLLECTION_ASK));
                      navigate("/collection/" + collection.id);
                    }}>
                    {collection.title}
                  </td>
                  <td>{formatDate(new Date(collection.createdAt))}</td>
                  <td>{getCollectionQuestionCount(collection.id)}</td>
                  <td>needed</td>
                  <td>{prettyCollectionAccessType(collection.accessType)}</td>
                  <td>
                    <div className="collection-card-table-buttons">
                      <div className="collection-card-table-resync">
                        <button
                          className="collections-button-negative"
                          onClick={async () => {
                            const result: EmbedCollectionResult | null =
                              await apiResyncCollection(collection.id);
                            if (
                              !result ||
                              result === EmbedCollectionResult.FAIL
                            ) {
                              toast("Resync Failed", toastFail);
                            }

                            if (result === EmbedCollectionResult.TOO_LARGE) {
                              toast(
                                "Collection too large to resync",
                                toastFail
                              );
                            }
                          }}>
                          Resync
                        </button>
                      </div>
                      <div
                        onClick={() => handleEditCollection(collection.id)}
                        className="collection-card-table-menu">
                        <img src={"/icons/edit_pencil.png"} />
                      </div>
                      <div
                        onClick={() => {
                          setDeleteCollectionId(collection.id);
                          setShowDeleteModal(true);
                        }}
                        className="collection-card-table-menu">
                        <img src={iconPath("trash.svg", storeUser)} />
                      </div>
                    </div>
                  </td>
                </tr>
              );
            })}
          {myCollections && myCollections.length === 0 && (
            <tr id="collection-card-table-tr">
              <td>You have not created any collections yet.</td>
              <td>{}</td>
              <td>{}</td>
              <td>{}</td>
              <td>{}</td>
              <td>{}</td>
            </tr>
          )}
        </tbody>
      </table>

      {showDeleteModal && (
        <ModalCollectionDelete
          isOpen={showDeleteModal}
          onClose={() => setShowDeleteModal(false)}
          onDelete={() => {}}
          collectionId={deleteCollectionId}
        />
      )}
    </>
  );
};
